export { AsideInfoLine } from './aside-info-line.component';
